// app/javascript/src/zip_validation.js
//
// Shows the red "check your ZIP" message on any input marked data-zip, and
// blocks submit until the ZIP is 5 digits or ZIP+4.
//
// WHY THIS EXISTS
// ----------------
// public.addresses.zip_code is an unbounded varchar, but the Heroku Connect
// mirror column sf.account.personmailingpostalcode is varchar(20). A parent
// pasted a 55-character street address into the ZIP box; SfAccountCreationJob's
// INSERT raised ValueTooLong, no PA_ row was minted, and the child stayed
// invisible to Salesforce for a day. Address rejects this on: :create — this is
// the same rule said early, in the form, so the parent fixes it in place.
//
// It deliberately does not rewrite what the parent typed. Stripping non-digits
// would turn a pasted "1234 Example St, Provo UT 84604" into a well-formed
// WRONG ZIP that passes every check downstream.

const ZIP = /^\d{5}(-\d{4})?$/;

function messageFor(input) {
  return input.parentNode && input.parentNode.querySelector(".zip-error");
}

function check(event) {
  const input = event.target;
  if (!input.matches || !input.matches("input[data-zip]")) return;
  const value = input.value.trim();
  // An empty box is `required`'s message to give, not ours.
  const ok = value === "" || ZIP.test(value);
  const msg = messageFor(input);
  if (msg) msg.classList.toggle("is-hide", ok);
}

function onSubmit(event) {
  let firstBad = null;
  event.target.querySelectorAll("input[data-zip]").forEach(function (input) {
    const ok = ZIP.test(input.value.trim());
    const msg = messageFor(input);
    if (msg) msg.classList.toggle("is-hide", ok);
    if (!ok && !firstBad) firstBad = input;
  });
  if (!firstBad) return;
  event.preventDefault();
  event.stopPropagation();
  firstBad.focus();
}

document.addEventListener("submit", onSubmit, true); // capture: beat the form's own handler
document.addEventListener("input", check, true);
document.addEventListener("change", check, true);
